import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 16px;
  height: 16px;
  color: #1e7be2;
`

const AddPlus = ({ title = 'Add', ...rest }: IconProps) => (
  <StyledIcon viewBox="0 0 16 16" title={title} {...rest}>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="surveys-questions-2c" transform="translate(-349.000000, -702.000000)">
        <g id="surveys-audience2">
          <g id="Add-questions" transform="translate(331.000000, 429.000000)">
            <g id="add-answer" transform="translate(18.000000, 270.000000)">
              <g id="icon_add_answer" transform="translate(0.000000, 3.000000)">
                <circle id="Oval" fill="currentColor" cx="8" cy="8" r="8" />
                <path
                  d="M8,4.48079759 L8,11.5177858"
                  id="Shape"
                  stroke="#FFFFFF"
                  strokeWidth="3"
                  strokeLinecap="square"
                />
                <path
                  d="M11.5192024,8 L4.48221424,8"
                  id="Shape"
                  stroke="#FFFFFF"
                  strokeWidth="3"
                  strokeLinecap="square"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </StyledIcon>
)

AddPlus.needsWork = true
AddPlus.displayName = 'AddPlusIcon'
export default AddPlus
